export default function useCookie() {
  const setCookie = (name, value) => {
    const Days = 100;
    const exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(
      value
    )};expires=${exp.toUTCString()}`;
  };

  const getCookie = (name) => {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    } else {
      return null;
    }
  };

  const delCookie = (name) => {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = getCookie(name);
    if (cval != null)
      document.cookie = `${name}=${encodeURIComponent(
        cval
      )};expires=${exp.toUTCString()}`;
  };

  return {
    setCookie,
    getCookie,
    delCookie,
  };
}
